
function CoinMetadata({coin_metadata}){
  console.log("FRONTEND",coin_metadata)
  if(coin_metadata !== ""){
  return (
    <>
      <div className=" bg-light pt-2" style={{ minHeight: "20vh" }}>
        <div>
          {coin_metadata.description!==""?(
          <>
          <h3>Description</h3>
          <p>{coin_metadata.description}</p>
          </>
          ):""}
        </div>
        <div className="py-3">
          <h3>Information Sources</h3>
          <div className="d-flex flex-wrap">
            {coin_metadata.website_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.website_url} class="btn btn-secondary mr-2">Website</a>
            ):""}
            {coin_metadata.blog_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.blog_url} class="btn btn-primary mr-2">Blog</a>
            ):""}
            {coin_metadata.medium_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.medium_url} class="btn btn-warning mr-2">Medium</a>
            ):""}
            {coin_metadata.github_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.github_url} class="btn btn-dark mr-2">Github</a>
            ):""}
            {coin_metadata.whitepaper_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.whitepaper_url} class="btn btn-danger mr-2">White Paper</a>
            ):""}
          </div>
        </div>
        <div className="py-3">
          <h3>Social Accounts</h3>
          <div className="d-flex flex-wrap">
            {coin_metadata.discord_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.discord_url} class="btn mr-2 text-white" style={{background:"#6F86D4"}}>Discord</a>
            ):""}
            {coin_metadata.facebook_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.facebook_url} class="btn mr-2 text-white" style={{background:"#4267B2"}}>Facebook</a>
            ):""}
            {coin_metadata.reddit_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.reddit_url} class="btn mr-2 text-white" style={{background:"#FF5700"}}>Reddit</a>
            ):""}
            {coin_metadata.telegram_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.telegram_url} class="btn mr-2 text-white" style={{background:"#0088cc"}}>Telegram</a>
            ):""}
            {coin_metadata.twitter_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.twitter_url} class="btn  mr-2 text-white" style={{background:"#1da1f2"}}>Twitter</a>
            ):""}
            {coin_metadata.youtube_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.youtube_url} class="btn  mr-2 text-white" style={{background:"#FF0000"}}>Youtube</a>
            ):""}
            {coin_metadata.linkedin_url !== ""?(
            <a  target="_blank" rel="noreferrer" href={coin_metadata.linkedin_url} class="btn  mr-2 text-white" style={{background:"#0e76a8"}}>LinkedIn</a>
            ):""}
          </div>
        </div>
        <hr className="bg-light my-1 my-sm-3"></hr>
      </div>
    </>
  )}else{
    return ""
  }
}

function Coin({coin}){
  if(coin !== ""){
  return(
    <div className="">
      <div className="d-flex align-items-center flex-wrap pb-3">
        <img src={coin.logo_url} alt="crypto logo" style={{width:50}}/>
        <h3 className="mx-2">{coin.name}</h3>
        <h3 className="mx-2">({coin.symbol})</h3>
        {coin.status==="active"?(
        <h3 class="btn btn-success mx-2 my-2">{coin.status.charAt(0).toUpperCase()+coin.status.slice(1)}</h3>
        ):(
        <h3 class="btn btn-danger mx-2 my-2">{coin.status.charAt(0).toUpperCase()+coin.status.slice(1)}</h3>
        )}
      </div>
      <h3>Quote</h3>
      {coin.rank !== ""?(
      <h5>Rank: {coin.rank}</h5>
      ):""}
      {coin.price !== ""?(
      <p>Price: {coin.price > 0?(<span className="text-success">{coin.price}</span>):(<span className="text-danger">{coin.price}</span>)}</p>
      ):""}
      {console.log(coin["1d"])}
      {coin["1d"] !== "" && coin["1d"] !== undefined ?(
      <p>Price Percentage Change: {coin["1d"]?.price_change_pct > 0?(<span className="text-success">{Math.round(coin["1d"].price_change_pct*100)} %</span>):(<span className="text-danger">{Math.round(coin["1d"].price_change_pct*100)} %</span>)}</p>
      ):""}
      {coin.circulating_supply !== ""?(
      <p>Circulating Supply: {coin.circulating_supply}</p>
      ):""}
      {coin.max_supply !== ""?(
      <p>Max Supply: {coin.max_supply}</p>
      ):""}
      {coin.market_cap !== ""?(
      <p>Market Cap: {coin.market_cap}</p>
      ):""}
      {coin.first_trade !== ""?(
      <p>First Trade Date: {coin.first_trade}</p>
      ):""}
      {coin.high !== ""?(
      <p>High: {coin.high}</p>
      ):""}
    </div>
  )}else{
    return ""
  }
}






function Coins({ coin,coin_metadata }) {
  return(
    <div className="p-4 bg-light">
      <h4 className="">Penny Botz Crypto Research Dashboard</h4>
      <hr className="bg-light my-1 my-sm-3"></hr>
      <hr className="bg-light my-1 my-sm-3"></hr>
      <Coin coin={coin}/>
      <CoinMetadata coin_metadata={coin_metadata}/>
    </div>
  )
}

export default Coins;